import React from 'react';
import { useActivityInformationTravellersQuery } from '../../features/activities/informationDisplays/api/useActivityInformationTravellersQuery.ts';

interface EntityNoteTravellerDisplayProps {
  travellerId: number;
}

const EntityNoteTravellerDisplay: React.FC<EntityNoteTravellerDisplayProps> = (
  props: EntityNoteTravellerDisplayProps
) => {
  const getTraveller = useActivityInformationTravellersQuery([props.travellerId]);

  if (getTraveller.isLoading) {
    return <div>Loading...</div>;
  }
  if (getTraveller.isError) {
    return <div>Error: {getTraveller.error.message}</div>;
  }
  if (!getTraveller.data || getTraveller.data.length === 0) {
    return <div>No traveller data found.</div>;
  }
  return (
    getTraveller &&
    getTraveller.data && (
      <div>
        <h2>
          {getTraveller.data![0].FirstName} {getTraveller.data![0].LastName}
        </h2>
      </div>
    )
  );
};

export default EntityNoteTravellerDisplay;
